import { AppState } from "../app.state";

export const getEmailModalWindow = (state: AppState) => state.changeEmail.isOpen;

export const getChangeEmailStatus = (state: AppState) => state.changeEmail.loadStatus;
